/**
 * Lightweight email validation for the bootstrap bundle.
 */
export default function isValidEmail(email: string): boolean {
  if (!email || typeof email !== 'string') return false;

  // Standard email regex that covers the same cases as email-validator
  // Requires: local@domain.tld format, no consecutive dots, valid chars
  const emailRegex =
    /^(?!.*\.\.)[^\s@]+@[A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?)*\.[A-Za-z]{2,}$/;
  return emailRegex.test(email);
}
